import { inject, injectable } from "inversify";
import { ServiceResponse, IApiClient, IApiClientId } from "@se/platform";
import { ICookieService } from "../interfaces/cookieService";

@injectable()
class CookieService implements ICookieService {

    constructor(
        @inject(IApiClientId) private apiClient: IApiClient,
        @inject(Symbol.for("Gtag.Gtag")) private googleGTag: Gtag.Gtag) {
    }

    public async SaveConsentCookie(AllowMarketingCookies: boolean, AllowFunctionalCookies: boolean, AllowPerformanceCookies: boolean): Promise<ServiceResponse<string>> {
        
        this.googleGTag.call(this,'consent', 'update', {
            ad_storage: AllowMarketingCookies == true ? 'granted' : 'denied',
            analytics_storage: AllowPerformanceCookies == true ? 'granted' : 'denied',
            ad_user_data: AllowMarketingCookies == true ? 'granted' : 'denied',
            ad_personalization: AllowMarketingCookies == true ? 'granted' : 'denied',
            functionality_storage: AllowFunctionalCookies == true ? 'granted' : 'denied',
        });

        // content comes from the site itself
        var payload: any = {
            'StrictlyNecessary': true,
            'Marketing': AllowMarketingCookies,
            'Functional': AllowFunctionalCookies,
            'Performance': AllowPerformanceCookies
        };

        const baseUrl = location.origin;
        const response = await this.apiClient.Post<string, string>(baseUrl, `cookies/permissions`, payload, null);
        return response;
    }

    public async GetConsentCookiePermissions(): Promise<ServiceResponse<string>> {
        const baseUrl = location.origin;
        const response = await this.apiClient.Get<string>(baseUrl, `cookies/permissions`, null);
        return response;
    }
};

export { CookieService }